import AuthSimpleLayout from 'layouts/AuthSimpleLayout';
import AccountCreateStatus from 'components/modules/auth/AccountCreateStatus';

const SignOut = () => {
  return (
    <AuthSimpleLayout logo={false}>
      <AccountCreateStatus layout="simple" />
    </AuthSimpleLayout>
  );
};

export default SignOut;
